// @flow

import * as React from 'react';

import type { PreFetchArgs, PreFetchReturn } from '@gandi/app-runner/server';

import { stopSSE } from 'src/modules/app/sse';

import { Layout } from '../components/Layout';

import { handleMarketingParams } from '../modules/app/actions';
import type { StaticHandlerArgsWithMarketing } from '../modules/app/actions';
import setPublicHTTPCache from '../modules/app/public-http-cache';
import type { FullState } from '../types';

import DomainSuggest, {
  type Query as DomainSuggestQuery,
} from './components/DomainSuggest';

export type DomainCreateDispatchProps = {
  fetchIDNAvailableLanguages: () => void,
  fetchCorporatePackMonthlyPrices: () => void,
  resetResults: () => void,
  resetSearch: () => void,
};

type DomainCreateProps = {
  hasCorporateTLDs: boolean,
  hasIDNResults: boolean,
  ...DomainCreateDispatchProps,
};

export default class DomainCreate extends React.Component<DomainCreateProps> {
  static handleForm(args: StaticHandlerArgsWithMarketing<>): Promise<void> {
    return handleMarketingParams(args);
  }

  static async handleRedirect(args: StaticHandlerArgsWithMarketing<>) {
    await handleMarketingParams(args);
    await Layout.handleRedirect(args);
    // $FlowFixMe[incompatible-call]
    setPublicHTTPCache(args);
  }

  static preFetch(
    args: PreFetchArgs<{}, void, DomainSuggestQuery, FullState>,
  ): PreFetchReturn<> {
    return Promise.allSettled([
      DomainSuggest.preFetch(args),
      Layout.preFetch(args),
    ]);
  }

  componentDidUpdate(prevProps: DomainCreateProps) {
    if (!prevProps.hasCorporateTLDs && this.props.hasCorporateTLDs) {
      this.props.fetchCorporatePackMonthlyPrices();
    }

    if (!prevProps.hasIDNResults && this.props.hasIDNResults) {
      this.props.fetchIDNAvailableLanguages();
    }
  }

  componentWillUnmount() {
    this.props.resetResults();
    this.props.resetSearch();
    stopSSE();
  }

  render(): React.Node {
    return (
      <Layout>
        <DomainSuggest />
      </Layout>
    );
  }
}
